import React from "react";
import { OspIcons } from "@ospweb/sdk-ui/src/Icon/OspIcons";
import { cn } from "utils";
import { ospThemes } from "@ospweb/sdk-ui";
import type { DropDownOption } from "./types";

interface DropDownOptionItemProps {
  option: DropDownOption;
  selected: boolean;
  onSelect: (option: DropDownOption) => void;
  selectedIconName?: string;
}

export const DropDownOptionItem: React.FC<DropDownOptionItemProps> = ({
  option,
  selected,
  onSelect,
  selectedIconName,
}) => {
  const handleClick = React.useCallback(() => {
    if (!option.disabled) {
      onSelect(option);
    }
  }, [onSelect, option]);

  return (
    <button
      aria-label={option.label}
      data-openreplay-label={`${option.label} Button`}
      id="btn-drop-down-option-item"
      type="button"
      role="option"
      aria-selected={selected}
      data-tracking-scope="dropdown-option-item"
      className={cn(
        "flex h-10 w-full items-center gap-2 rounded-[6px] px-2 py-[10px] text-left transition-colors",
        "hover:bg-background_white_overlay10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-background_brand_overlay100 text-content_primary",
        option.disabled &&
          "cursor-not-allowed opacity-50 hover:bg-transparent focus-visible:ring-0",
      )}
      onClick={handleClick}
    >
      <span
        className={cn(
          "flex size-4 items-center justify-center",
          selected
            ? "rounded-[4px] bg-background_brand_overlay100 text-content_inverse_primary"
            : "rounded-[2px] bg-background_white_overlay10 text-content_secondary",
        )}
        aria-hidden="true"
      >
        {selected ? (
          <OspIcons
            name={selectedIconName ?? "check"}
            size={12}
            color={ospThemes.colors.content_inverse_primary}
            className="leading-none"
          />
        ) : null}
      </span>
      <span className="flex-1 truncate text-left body_medium_m">
        {option.label}
      </span>
    </button>
  );
};
